import React from "react";

import { setFilter } from "QuotePage/Actions";
import { getFavoritePlanIDs } from "QuotePage/Components/FavoritePlan";
import { getFilteredPlans } from "QuotePage/Selectors";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Popover } from "Cobalt/Popover";
import { Tab, Tabs } from "Cobalt/Tabs";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import SIOverlayTrigger from "Common/SIOverlayTrigger";

import { getRecommendationMode } from "./Selectors";

import type { Dispatch } from "redux";

type Props = {
  className?: string;
  currentRecommendationMode: string;
  totalItems: number;
  totalFavoritePlans: number;
  onClick: (arg0: string) => void;
  planPackagesAvailable: boolean;
  children?: React.ReactNode;
};

export const ShoppingTabsDumb = ({
  className,
  currentRecommendationMode,
  totalItems,
  totalFavoritePlans,
  planPackagesAvailable,
  onClick,
  children,
  ...rest
}: Props) => {
  return (
    <>
      <Div className={className} mb={4} {...rest}>
        <Tabs activeKey={currentRecommendationMode} onSelect={onClick} id="ShoppingTabs">
          <Tab eventKey="shop_all_plans" title={`Show all ${totalItems} Plans`} className="flex-auto" />

          <Tab eventKey="recommended" title="Recommended Plans" className="flex-auto" />
          {planPackagesAvailable && <Tab eventKey="multiple_plans" title="Plan Packages" className="flex-auto" />}

          <Tab
            eventKey="favorite_plans"
            title={
              <>
                {`Favorites ${totalFavoritePlans > 0 ? ` (${totalFavoritePlans})` : ""}`}
                &nbsp;
                <span className="text-red">
                  <Icon icon="heart" flavor="solid" />
                </span>
              </>
            }
            className="flex-auto"
          />

          <Tab eventKey="dental_plans" title="Dental Plans" className="flex-auto" />
          <Tab
            eventKey="limited_value_plans"
            title={
              <SIOverlayTrigger
                placement="bottom"
                overlay={
                  <Popover showBackdrop={false} id="mec_tab">
                    Minimum Essential Coverage and Minimum Value Plans
                  </Popover>
                }
              >
                <span>MEC/MVP Plans</span>
              </SIOverlayTrigger>
            }
            className="flex-auto"
          />
        </Tabs>
      </Div>
      {children}
    </>
  );
};

const mapStateToProps = (state) => ({
  currentRecommendationMode: getRecommendationMode(state),
  totalItems: getFilteredPlans(state).length,
  totalFavoritePlans: getFavoritePlanIDs(state).length,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  onClick: (value) => {
    AnalyticsTracking.trackEvent("switched_mode", {
      location: "quote_page",
      mode: value,
    });

    dispatch(setFilter("recommendation_mode", value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingTabsDumb);
